import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "Anmeldung fehlgeschlagen.");
    } finally {
      setLoading(false);
    }
  };

  const field = "w-full rounded-md border border-white/10 bg-[#0E0F12] px-3 py-2.5 text-sm text-white placeholder:text-gray-500 focus:border-[#3DDC97] focus:outline-none";

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0E0F12] px-6">
      <form onSubmit={submit} className="w-full max-w-sm rounded-xl border border-white/10 bg-[#14161B] p-8" data-testid="admin-login-form">
        <div className="mb-6 flex h-11 w-11 items-center justify-center rounded-md bg-[#3DDC97]/10 text-[#3DDC97]">
          <Lock size={20} />
        </div>
        <h1 className="font-display text-2xl font-bold text-white">Admin-Login</h1>
        <p className="mt-1 text-sm text-gray-500">BA Media Performance · CRM</p>
        <div className="mt-6 space-y-3">
          <input data-testid="login-email" className={field} type="email" placeholder="E-Mail" value={email} onChange={(e) => setEmail(e.target.value)} />
          <input data-testid="login-password" className={field} type="password" placeholder="Passwort" value={password} onChange={(e) => setPassword(e.target.value)} />
        </div>
        {error && <p data-testid="login-error" className="mt-3 text-sm text-red-400">{error}</p>}
        <button data-testid="login-submit" type="submit" disabled={loading} className="mt-6 w-full rounded-md bg-[#3DDC97] py-3 font-semibold text-[#0E0F12] hover:bg-[#2BBF7E] disabled:opacity-50">
          {loading ? "Anmelden …" : "Anmelden"}
        </button>
      </form>
    </div>
  );
}
